export function formatNumberTwoDecimals(value: any): string {
  const num = parseFloat(value);
  if (isNaN(num) || value === '' || value === null || value === undefined) {
    return '0.00';
  }
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function getUtilityFormatted(value: any): string {
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00 %';
  return `${num.toFixed(2)} %`;
}
